import React, { FC, memo } from 'react';
import { useRouter } from '@blocs.router';
import Button from '@minecraft.button';
import { useTranslation } from '@blocs.i18n';
import { ButtonGroup } from '../FilterOverlayFormStyles';

type Props = {
  showAdvancedSearchButton?: boolean;
  advancedSearchRoute?: string;
  searchButtonLabel?: string;
};

const FilterOverlayFormButtonGroup: FC<Props> = ({
  showAdvancedSearchButton = false,
  advancedSearchRoute,
  searchButtonLabel = 'Filter',
}) => {
  const { t } = useTranslation();
  const { navigate } = useRouter();

  const handleGoToAdvancedFiltersClick = () => {
    navigate({ to: advancedSearchRoute });
  };
  return (
    <ButtonGroup>
      <Button type="submit">{searchButtonLabel}</Button>
      {showAdvancedSearchButton && !!advancedSearchRoute && (
        <Button outlined type="button" onClick={handleGoToAdvancedFiltersClick}>
          {t('common:button.goToAdvancedFilters')}
        </Button>
      )}
    </ButtonGroup>
  );
};

export default memo(FilterOverlayFormButtonGroup);
